import { useQuery } from '@apollo/client';
import PropTypes from 'prop-types';
import React, { useMemo, useState } from 'react';
import { ContentIcon, Search, ColorBadge, Theme } from '@spoiler-alert/ui-library';
import { createUseStyles } from 'react-jss';
import { SitesByRoleAndType } from '../../graphql/queries';
import { VColumn, VRowAction, VTable } from '../../components/v-table';
import routePaths from '../../route-paths';

const useStyles = createUseStyles({
  wrap: {
    position: 'relative',
  },
  mapContainer: {
    width: '100%',
    height: 400,
    border: `2px solid ${Theme.greyDark}`,
    overflow: 'hidden',
  },
  header: {
    padding: 10,
    display: 'flex',
    gap: 10,
    borderBottom: `1px solid ${Theme.grey10}`,
  },
  search: {},
});

const BuyerSites = ({ history }) => {
  const classes = useStyles();
  const [searchText, setSearchText] = useState('');
  const { data, loading } = useQuery(SitesByRoleAndType, {
    variables: {
      siteRoles: ['BUYER'],
      siteTypes: ['ORGANIZATION'],
    },
  });

  const sitesList = data?.adminSitesQuery || [];

  const siteColumns = useMemo(() => {
    return [
      new VColumn({
        field: 'siteName',
        displayName: 'Site Name',
        sortable: true,
        defaultSort: true,
        defaultSortDirection: 'asc',
        formatter: (value, row) => (
          <span>
            <span>{value}</span> {row.archived ? <ColorBadge theme="grey">Archived</ColorBadge> : ''}
          </span>
        ),
      }),
      new VColumn({
        field: 'siteType',
        displayName: 'Site Type',
        sortable: true,
      }),
      new VColumn({
        field: 'physicalAddress.content',
        displayName: 'Address',
        sortable: true,
      }),
    ];
  }, []);

  const handleRowClick = (row) => {
    history.push(`${routePaths.sites}/${row._id}`);
  };

  const handleSearch = (text) => {
    setSearchText(text);
  };

  return (
    <div className={classes.wrap}>
      <div className={classes.header}>
        <Search onChange={handleSearch} className={classes.search} />
      </div>
      <VTable
        searchText={searchText}
        cols={siteColumns}
        data={sitesList}
        loading={loading}
        rowActionsWidth={120}
        rowActions={[
          <VRowAction
            key="edit"
            label="Facilities"
            onClick={(row) => () => handleRowClick(row)}
            tooltipText="Inspect Hierarchy"
          />,
        ]}
      />
    </div>
  );
};

BuyerSites.propTypes = {
  history: PropTypes.object,
};

export default BuyerSites;
